const postInvoiceTypes = {
    lockSystemAdditionalUserAddition: {},
};

Object.keys(postInvoiceTypes).forEach(key => {
    postInvoiceTypes[key].key = key;
});

export default postInvoiceTypes;
